import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { SignupState } from '../../utils/enums/SignupState';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

export default function SignupLoadingState({ step }) {

  const { t } = useTranslation();

  const getLoadingMessage = () => {
    switch (step) {
      case SignupState.NEEDS_PROFILE:
        return {
          title: t(StringKeys.SAVING_YOUR_PROFILE),
          subtitle: t(StringKeys.PLEASE_WAIT_WHILE_WE_UPDATE_YOUR_INFORMATION)
        };
      case SignupState.NEEDS_ORGANIZATION:
        return {
          title: t(StringKeys.SETTING_UP_YOUR_ORGANIZATION),
          subtitle: t(StringKeys.PLEASE_WAIT_WHILE_WE_CREATE_YOUR_ORGANIZATION)
        };
      case SignupState.NEEDS_SUBSCRIPTION:
        return {
          title: t(StringKeys.PROCESSING_PAYMENT_INFORMATION),
          subtitle: t(StringKeys.PLEASE_WAIT_WHILE_WE_SETUP_YOUR_SUBSCRIPTION)
        };
      default:
        return {
          title:   t(StringKeys.PROCESSING) + "...",
          subtitle: t(StringKeys.PLEASE_WAIT_WHILE_WE_COMPLETE_YOUR_REQUEST)
        };
    }
  };

  const { title, subtitle } = getLoadingMessage();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: 2, md: 3 },
        width: '100%',
        height: '100%',
        flex: 1,
        p: { xs: 2, md: 4 }
      }}
    >
      <CircularProgress size={48} />
      <Typography 
        variant="h6" 
        align="center"
        sx={{
          fontSize: { xs: '1.125rem', md: '1.25rem' },
          fontWeight: 600,
          color: 'text.primary'
        }}
      >
        {title}
      </Typography>
      <Typography 
        variant="body2" 
        color="text.secondary" 
        align="center"
        sx={{
          fontSize: { xs: '0.875rem', md: '1rem' },
          maxWidth: '80%'
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
} 